import React from 'react';
import styled from '@emotion/styled';
import { ExternalLink } from 'lucide-react';

/** A static pre-work task on /me: a title, a text to read, a link. No state. */

const Card = styled.div`
  background: #141821;
  border: 1px solid #232a36;
  border-radius: 10px;
  padding: 1.25rem 1.35rem;
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
`;

const Link = styled.a`
  color: #6fd3c8;
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
`;

export default function StaticTask({ task }) {
  return (
    <Card>
      {task.title && <strong>{task.title}</strong>}
      {task.body && <div style={{ whiteSpace: 'pre-wrap', lineHeight: 1.55 }}>{task.body}</div>}
      {task.url && (
        <Link href={task.url} target="_blank" rel="noreferrer">
          {task.linkText || task.url.replace(/^https?:\/\//, '')} <ExternalLink size={14} />
        </Link>
      )}
    </Card>
  );
}
